import {
    CREATE_USER,
    CREATE_USER_SUCCESS,
    DELETE_USER,
    DELETE_USER_SUCCESS,
    LIST_USERS,
    RESET_USER_PASSWORD,
    UPDATE_USER,
    UPDATE_USER_SUCCESS,
} from './UsersActionTypes';
import {catchError, map, switchMap} from 'rxjs/operators';
import {combineEpics} from 'redux-observable';
import config from 'react-global-configuration';
import {usersActions} from './'
import {
    deleteWithAuth,
    errorHandlingWithLogoutCheck,
    getJsonWithAuth,
    postJsonWithAuth,
    putJsonWithAuth
} from "../../../components/AjaxHelpers";

export const usersEpics = combineEpics(
    // Events of type LIST_USERS
    (action$, state$) => action$.ofType(LIST_USERS).pipe(
        switchMap(action =>
            getJsonWithAuth({
                url: config.get('apiBaseUrl') + '/user/v1/users',
                state: state$.value
            }).pipe(
                map(payload => usersActions.listUsersSucceeded(payload)),
                catchError(response => errorHandlingWithLogoutCheck(response, [usersActions.listUsersFailed(response)]))
            )
        )
    ),

    (action$, state$) => action$.ofType(CREATE_USER).pipe(
        switchMap(action =>
            postJsonWithAuth({
                url: config.get('apiBaseUrl') + '/user/v1/users',
                body: {
                    username: action.userForm.username,
                    password: action.userForm.password,
                    firstName: action.userForm.firstName,
                    lastName: action.userForm.lastName,
                    role: action.userForm.role,
                    organizationId: action.userForm.organization,
                    email: action.userForm.email
                },
                state: state$.value
            }).pipe(
                map(payload => usersActions.createUserSucceeded(payload)),
                catchError(error => errorHandlingWithLogoutCheck(error, [usersActions.createUserFailed(error)]))
            )
        )
    ),

    (action$, state$) => action$.ofType(CREATE_USER_SUCCESS).pipe(
        map(action => usersActions.listUsers())
    ),


    (action$, state$) => action$.ofType(UPDATE_USER).pipe(
        switchMap(action =>
            putJsonWithAuth({
                url: config.get('apiBaseUrl') + '/user/v1/users/' + action.userForm.username,
                body: {
                    username: action.userForm.username,
                    firstName: action.userForm.firstName,
                    lastName: action.userForm.lastName,
                    role: action.userForm.role,
                    email: action.userForm.email,
                    organizationId: action.userForm.organization
                },
                state: state$.value
            }).pipe(
                map(payload => usersActions.updateUserSucceeded(payload)),
                catchError(error => errorHandlingWithLogoutCheck(error, [usersActions.updateUserFailed(error)]))
            )
        )
    ),
    (action$, state$) => action$.ofType(UPDATE_USER_SUCCESS).pipe(
        map(action => usersActions.listUsers())
    ),

    (action$, state$) => action$.ofType(DELETE_USER).pipe(
        switchMap(action =>
            deleteWithAuth({
                url: config.get('apiBaseUrl') + '/user/v1/users/' + action.username,
                state: state$.value
            }).pipe(
                map(payload => usersActions.deleteUserSucceeded()),
                catchError(error => errorHandlingWithLogoutCheck(error, [usersActions.deleteUserFailed(error)]))
            )
        )
    ),
    (action$, state$) => action$.ofType(DELETE_USER_SUCCESS).pipe(
        map(action => usersActions.listUsers())
    ),

    (action$, state$) => action$.ofType(RESET_USER_PASSWORD).pipe(
        switchMap(action =>
            deleteWithAuth({
                url: config.get('apiBaseUrl') + '/user/v1/users/' + action.username + '/password',
                state: state$.value
            }).pipe(
                map(payload => usersActions.resetUserPasswordSucceeded()),
                catchError(error => errorHandlingWithLogoutCheck(error, [usersActions.resetUserPasswordFailed(error)]))
            )
        )
    ),

);
